import { createRouter, createWebHistory } from 'vue-router';
import Events from './views/Events.vue';

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'events',
      component: Events,
    },
  ],
});
